export default [
    {
        week: 1,
        name: {
            'de': 'Dschungolino',
            'en': 'Dschungolino'
        },
        route: 'w1d1exploration1'
    },
    {
        week: 2,
        name: {
            'de': 'Blutopia',
            'en': 'Blutopia'
        },
        route: 'w2d1exploration1'
    },
    {
        week: 3,
        name: {
            'de': 'Elektro',
            'en': 'Electro'
        },
        route: 'w3d1exploration1'
    },
    {
        week: 4,
        name: {
            'de': 'Sportopia',
            'en': 'Sportopia'
        },
        route: 'w4d1exploration1'
    }
];
